import Modal, { styles } from './modal';

export { styles };
export default Modal;
